var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("apexchart", {
        ref: "chart",
        staticStyle: { "margin-top": "-40px" },
        attrs: {
          width: "100%",
          height: _vm.chartHeight,
          options: _vm.chartOptions,
          series: _vm.fromSeries
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }